<template>
  <v-container fluid >
    <v-layout justify-space-between text-xs-center>
<v-card dark height="300px" color="alert" >
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Nothing to see here yet.
                </h3>
            </div>
          </v-card-title>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
export default {

}
</script>



// WEBPACK FOOTER //
// src/components/User/About.vue